// export const fullTourSteps = [
//     /* ---------------- DASHBOARD ---------------- */
//     {
//         route: "/dashboard",
//         selector: ".start-exam-btn",
//         title: "Start Exam",
//         text: "Click here to begin your exam.",
//     },

//     /* ---------------- INSTRUCTIONS ---------------- */
//     {
//         route: "/dummy-instructions",
//         selector: ".tour-checkbox",
//         title: "Confirm Instructions",
//         text: "Please confirm that you’ve read the instructions.",
//     },
//     {
//         route: "/dummy-instructions",
//         selector: ".proceed-btn",
//         title: "Proceed to Exam",
//         text: "Click here to enter the exam.",
//     },

//     /* ---------------- EXAM PAGE ---------------- */

//     {
//         route: "/dummy-exampage",
//         selector: ".CourseBox", // ⬅️ add this class to DummyExamHeader root
//         title: "Exam Header",
//         text: "Here you can see the exam title and remaining time.",
//     },
//     {
//         route: "/dummy-exampage",
//         selector: ".question-card", // ⬅️ add to DummyExamQuestionCard root
//         title: "Question Area",
//         text: "Read the question carefully before answering.",
//     },
//     {
//         route: "/dummy-exampage",
//         selector: ".options-container", // ⬅️ wrap options with this class
//         title: "Answer Options",
//         text: "Select the correct answer(s) here.",
//     },
//     {
//         route: "/dummy-exampage",
//         selector: ".question-actions", // ⬅️ container for buttons
//         title: "Question Actions",
//         text: "Use these buttons to navigate, clear answers, or mark for review.",
//     },
//     {
//         route: "/dummy-exampage",
//         selector: ".question-navigator", // ⬅️ add to QuestionNavigator
//         title: "Question Palette",
//         text: "Jump directly to any question using this panel.",
//     },
//     {
//         route: "/dummy-exampage",
//         selector: ".progress-overview", // ⬅️ add to ProgressOverview
//         title: "Progress Overview",
//         text: "Track answered, unanswered, and marked questions here.",
//     },
//     {
//         route: "/dummy-exampage",
//         selector: ".submit-exam-btn", // ⬅️ submit button
//         title: "Submit Exam",
//         text: "Click here once you have completed the exam.",
//         action: "OPEN_SUBMIT_DIALOG",
//     },
//     /* ---------------- SUBMIT DIALOG ---------------- */
//     /* ---------------- SUBMIT DIALOG ---------------- */
//     // {
//     //     route: "/dummy-exampage",
//     //     selector: ".submit-exam-dialog",
//     //     title: "Submit Confirmation",
//     //     text: "This dialog confirms your exam submission.",
//     // },
//     {
//         route: "/dummy-exampage",
//         selector: ".submit-summary",
//         title: "Submission Summary",
//         text: "Review answered, unanswered and marked questions.",
//     },
//     {
//         route: "/dummy-exampage",
//         selector: ".submit-cancel-btn",
//         title: "Submission Summary",
//         text: "Review answered, unanswered and marked questions.",
//     },
//     {
//         route: "/dummy-exampage",
//         selector: ".final-submit-btn",
//         title: "Final Submit",
//         text: "Click here to submit the exam permanently.",
//     },
// ];


export const fullTourSteps = [
    /* ---------------- DASHBOARD ---------------- */
    {
        route: "/dummy-userdashboard",
        selector: ".theory-start-exam-btn",
        title: "Start Your Exam",
        text: "Click this button to begin your scheduled Theory exam. Make sure you have a stable internet connection and sufficient time before starting.",
        allowInteraction: true,
    },

    /* ---------------- INSTRUCTIONS ---------------- */
    {
        route: "/dummy-instructions",
        selector: ".tour-checkbox",
        title: "Read and Confirm Instructions",
        text: "Carefully read all exam rules, guidelines, and restrictions. You must confirm that you understand them by selecting the checkbox before proceeding.",
        allowInteraction: true,
    },
    {
        route: "/dummy-instructions",
        selector: ".proceed-btn",
        title: "Proceed to Exam",
        text: "Once you are ready and have read all instructions, click here to enter the exam environment. The timer will begin after this.",
        allowInteraction: true,
    },

    /* ---------------- EXAM PAGE ---------------- */

    {
        route: "/dummy-exampage",
        selector: ".CourseBox",
        title: "Exam Header & Timer",
        text: "This section displays the exam name, and the remaining time. Keep an eye on the timer to manage your pace effectively.",
        allowInteraction: true,
    },
    {
        route: "/dummy-exampage",
        selector: ".question-card",
        title: "Question Panel",
        text: "This area shows the current question. Read the question carefully before selecting or changing your answer.",
        allowInteraction: true,
    },
    {
        route: "/dummy-exampage",
        selector: ".options-container",
        title: "Answer Options",
        text: "Choose the correct option(s) for the question. Your selection is automatically saved when you click on Save & Next button.",
        allowInteraction: true,
    },
    {
        route: "/dummy-exampage",
        selector: ".question-actions",
        title: "Question Controls",
        text: "Use these buttons to move to the next or previous question, clear your answer, or mark a question for later review.",
        allowInteraction: true,
    },
    {
        route: "/dummy-exampage",
        selector: ".question-navigator",
        title: "Question Navigator",
        text: "This panel allows you to jump directly to any question. Different colors indicate answered, unanswered, and marked-for-review questions.",
    },
    {
        route: "/dummy-exampage",
        selector: ".progress-overview",
        title: "Progress Overview",
        text: "This section provides a summary of your progress, including how many questions are answered, unanswered, or marked for review.",
    },
    {
        route: "/dummy-exampage",
        selector: ".submit-exam-btn",
        title: "Submit Exam",
        text: "When you have completed the exam or wish to end it early, click here. You will be asked to confirm your Submission before final submission.",
        action: "OPEN_SUBMIT_DIALOG",
    },

    /* ---------------- SUBMIT SUMMARY ---------------- */

    {
        route: "/dummy-exampage",
        selector: ".submit-summary",
        title: "Submission Summary",
        text: "Review a complete summary of your exam attempt, including answered, unanswered, and marked questions, before making the final decision.",
    },
    {
        route: "/dummy-exampage",
        selector: ".submit-cancel-btn",
        title: "Return to Exam",
        text: "If you wish to modify your answers, click here to return to the exam and continue attempting questions.",
    },
    {
        route: "/dummy-exampage",
        selector: ".final-submit-btn",
        title: "Final Exam Submission",
        text: "Click this button to permanently submit your exam. After submission, you will not be able to make any further changes.",
    },
    // ── Instructions Page ──
    {
        route: "/dummy-viva-instructions",           // ← adjust to your real route
        selector: ".tour-checkbox",             // we'll add this class to checkbox container
        title: "Read & Accept Instructions",
        text: "Read all instructions carefully and check this box to confirm that you accept the terms and conditions.",
        allowInteraction: true,
    },

    {
        route: "/dummy-viva-instructions",
        selector: ".proceed-btn",               // or ".btn" or whatever your Start Exam button class is
        title: "Start Your Exam",
        text: "Once you've confirmed the instructions, click here to begin the examination. Good luck!",
        allowInteraction: true,
    },
];


// toursteps.js   (replace or add this array)

// src/data/vivaTourSteps.js
// src/data/vivaTourSteps.js
export const vivaTourSteps = [
    {
        selector: ".checkbox-container.tour-checkbox",
        title: "Confirmation Checkbox",
        text: "Check this box to confirm that you have read and understood all the instructions.",
        allowInteraction: true,
        waitForRealCheckbox: true,   // auto-advance on check
        route: "/dummy-viva-instructions" 
    },
    {
        selector: ".btn-negative",   // ← the Cancel button
        title: "Cancel Button",
        text: "If you are not ready or want to exit, click the Cancel button here.",
        allowInteraction: true,
        route: "/dummy-viva-instructions" 
    },
    {
        selector: ".proceed-btn",
        title: "Start Viva Exam",
        text: "Once you've confirmed the instructions, click here to begin the viva examination.",
        allowInteraction: true,
        waitForRealClick: true ,
        route: "/dummy-viva-instructions" 
    },
    {
        selector: ".tour-exam-name",
        title: "Exam Name",
        text: "This shows the name of your exam.",
        autoNextAfter: 8000,
        route: "/dummy-viva-exam",
    },
    {
        selector: ".dummy-timer",
        title: "Exam Timer",
        text: "This shows remaining exam time.",
        autoNextAfter: 4000,
         route: "/dummy-viva-exam"
    },
    {
        selector: ".answer-button",
        title: "Answer Question",
        text: "Click here to start answering this question.",
        allowInteraction: true,
        waitForRealClick: true,
        route: "/dummy-viva-exam"
    },

    // -------- INSIDE POPUP --------

    {
        selector: ".tour-popup-topline",
        title: "Question",
        text: "Read your question carefully before answering.",
        autoNextAfter: 6000,
        route: "/dummy-viva-exam",
    },
    {
        selector: ".question-description",
        title: "Question Details",
        text: "This section shows the full description of the current question.",
        autoNextAfter: 3000,
        route: "/dummy-viva-exam"
    },
    {
        selector: ".tour-camera-area",
        title: "Camera Preview",
        text: "Your video is being recorded here.",
        autoNextAfter: 4000,
         route: "/dummy-viva-exam"
    },
    {
        selector: ".tour-audio-bar",
        title: "Audio Recording",
        text: "Your voice is being recorded.",
        autoNextAfter: 4000,
        route: "/dummy-viva-exam"
    },
    {
        selector: ".tour-save-btn",
        title: "Save Answer",
        text: "Click here to save your answer.",
        allowInteraction: true,
        waitForRealClick: true,
        route: "/dummy-viva-exam"
    },

    // -------- FINAL ACTIONS --------

    {
        selector: ".vivasubmit-btn",
        title: "Submit Exam",
        text: "Click here to submit your exam.",
        allowInteraction: true,
        waitForRealClick: true,
         route: "/dummy-viva-exam"
    },
    {
        selector: ".finalsubmit",
        title: "Submit Exam",
        text: "Check Once to finally submit the Exam.",
        allowInteraction: true,
        waitForRealClick: true,
         route: "/dummy-viva-exam"
    },
    {
        selector: ".tour-close-btn",
        title: "Finish",
        text: "Click close to finish the process.",
        allowInteraction: true,
        waitForRealClick: true,
         route: "/dummy-viva-exam"
    }
];

